/**
 * Canonical applicant id for table links and `/resident-detail/:applicantId/...` routes.
 * API often returns numeric ids; we display them zero-padded to 8 digits — the route must
 * use the same representation so the visible label matches the destination URL.
 */
export function formatApplicantIdSegment(id: string | number): string {
  const raw = String(id).trim()
  if (!/^\d+$/.test(raw)) return raw
  const normalized = raw.replace(/^0+/, '') || '0'
  return normalized.padStart(8, '0')
}
